import React, { Component } from 'react';
import { connect } from 'react-redux';
import TimeZoneSettingsForm, { selector as timeZoneSettingsFormSelector, initializeForm as initializeTimeZoneSettingsForm, initializeForm } from './TimeZoneSettingsForm';
import globalize from '../../common/services/globalize';

class TimeZoneSettings extends Component {
	constructor(props) {
		super(props);
		this.handleTimeZoneSettingsSubmit = this.handleTimeZoneSettingsSubmit.bind(this);
	}

	handleTimeZoneSettingsSubmit(values) {
		const { isAutomaticTimeZone, timeZone } = values;
		const { defaultTimeZone, initializeTimeZoneSettingsForm, franchisor } = this.props;		// use Franchisors time zone if none is selected
		globalize.setCurrentTimeZone(franchisor, isAutomaticTimeZone, timeZone || defaultTimeZone);

		// reinitialize the form using the new values
		initializeTimeZoneSettingsForm(this.getCurrentTimeZoneSettings());
	}

	getCurrentTimeZoneSettings() {
		const { franchisor } = this.props;
		return {
			isAutomaticTimeZone: globalize.isLocalTimeZone(franchisor),
			timeZone: globalize.getCurrentTimeZone(franchisor)
		};
	}

	render() {
		const { timeZoneSettingsFormValues, defaultTimeZone } = this.props;

		const initialFormValues = this.getCurrentTimeZoneSettings();

		return <TimeZoneSettingsForm onSubmit={this.handleTimeZoneSettingsSubmit} initialValues={initialFormValues} defaultTimeZone={defaultTimeZone} {...timeZoneSettingsFormValues} />;
	}
}

const mapStateToProps = state => ({
	timeZoneSettingsFormValues: { isAutomaticTimeZone: timeZoneSettingsFormSelector(state, 'isAutomaticTimeZone') },
	defaultTimeZone: state.configuration.franchisor.timeZone,
	franchisor: state.configuration.franchisor
});

export default connect(mapStateToProps, {
	initializeTimeZoneSettingsForm
})(TimeZoneSettings);